import React from 'react';
import { cn } from '../../utils/cn';

const Switch = React.forwardRef(
  (
    {
      className,
      id,
      checked = false,
      disabled = false,
      label,
      description,
      onChange,
      ...props
    },
    ref,
  ) => {
    const switchId =
      id || `switch-${Math.random()?.toString(36)?.substr(2, 9)}`;

    const toggle = () => {
      if (disabled) return;
      onChange?.({ target: { checked: !checked } });
    };

    return (
      <div className={cn('flex items-start justify-between gap-3', className)}>
        {(label || description) && (
          <div className="flex-1 space-y-0.5 min-w-0">
            {label ? (
              <label
                htmlFor={switchId}
                className={cn(
                  'text-sm font-medium leading-none cursor-pointer',
                  disabled ? 'cursor-not-allowed opacity-70' : 'text-foreground',
                )}
              >
                {label}
              </label>
            ) : null}
            {description ? (
              <p className="text-xs text-muted-foreground">{description}</p>
            ) : null}
          </div>
        )}
        <button
          type="button"
          ref={ref}
          id={switchId}
          role="switch"
          aria-checked={checked}
          disabled={disabled}
          onClick={toggle}
          className={cn(
            'relative inline-flex h-5 w-9 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background',
            checked ? 'bg-primary' : 'bg-muted',
            disabled && 'cursor-not-allowed opacity-50',
          )}
          {...props}
        >
          <span
            aria-hidden="true"
            className={cn(
              'pointer-events-none block h-4 w-4 rounded-full bg-background shadow-sm transition-transform',
              checked ? 'translate-x-4' : 'translate-x-0',
            )}
          />
        </button>
      </div>
    );
  },
);

Switch.displayName = 'Switch';

export { Switch };
